module.exports = __webpack_public_path__ + "img/Group3.5c3dd803.svg";